import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import EditUsers from "../EditUsers";
import CustomTooltip from "../../../common/CustomTooltip";
import UserDelete from "./UserDelete";
import ActivityLogList from "../../../common/ActivityLogList";

const UsersActionButton = ({ id, usersModal, fetchUsers }) => {
  const [showDelete, setShowDelete] = useState(false);
  const [showUsers, setShowUsers] = useState(false);

  const toggleUsersModal = () => {
    showUsers && usersModal();

    setShowUsers(!showUsers);
  };

  const toggleDeleteModal = () => {
    setShowDelete(!showDelete);
  };

  return (
    <>
      <ActivityLogList id={id} />
      <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
      <CustomTooltip message={"Edit"}>
        <span>
          <FontAwesomeIcon icon={faEdit} size="1x" onClick={toggleUsersModal} />
        </span>
      </CustomTooltip>
      <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
      <CustomTooltip message={"Delete"}>
        <span>
          <FontAwesomeIcon
            onClick={toggleDeleteModal}
            icon={faTrash}
            size="1x"
            data-toggle="modal"
            data-target="#deleteClient"
          />
        </span>
      </CustomTooltip>
      {showUsers && (
        <EditUsers
          usersId={id}
          showUsers={showUsers}
          toggleUsersModal={toggleUsersModal}
        />
      )}
      {showDelete && (
        <UserDelete
          userId={id}
          toggleDeleteModal={toggleDeleteModal}
          handleDelete={fetchUsers}
          showDelete={showDelete}
        />
      )}
    </>
  );
};

export default UsersActionButton;
